import { createRouter, createWebHistory } from 'vue-router'
import { parseJwt } from '../globals'

const MainApp = () => import('@/components/MainApp.vue')
const AuthApp = () => import('@/components/auth/AuthApp.vue')
const FirmwareInstaller = () => import('@/components/firmwareInstaller/FirmwareInstallerView.vue')
const Firmware = () => import('@/components/firmware/Firmware.vue')
const Search = () => import('@/components/search/Search.vue')
const UserManagement = () => import('@/components/userManagement/UserManagement.vue')

const routes = [
  {
    path: '/',
    name: 'app',
    beforeEnter: (_to, _from, next) => {
      const token = localStorage.getItem('token')
      if (token) {
        const { role } = parseJwt(token)
        switch (role) {
          case 'Admin': router.push({ name: 'firmware' }); break
          default: router.push({ path: '/login' }); break
        }
      } else {
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/app',
    component: MainApp,
    meta: { requireAuth: true },
    children: [
      {
        name: 'firmwareInstaller',
        path: 'firmware-installer',
        component: FirmwareInstaller,
        meta: { requireAuth: true, roles: ['Admin', 'TechSupport', 'SuperAdmin', 'Integrator'] },
      },
      {
        name: 'firmware',
        path: 'firmware',
        component: Firmware,
        meta: { requireAuth: true, roles: ['Admin', 'TechSupport', 'SuperAdmin', 'Integrator'] },
      },
      {
        name: 'search',
        path: 'search',
        component: Search,
        meta: { requireAuth: true, roles: ['Admin', 'TechSupport', 'SuperAdmin'] },
      },
      {
        name: 'userManagement',
        path: 'user-management',
        component: UserManagement,
        meta: { requireAuth: true, roles: ['Admin', 'SuperAdmin'] },
      },
      { path: '', redirect: { name: 'app' } },
    ],
  },
  { name: 'login', path: '/login', component: AuthApp },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to, from, next) => {
  const { requireAuth } = to.meta
  if (requireAuth) {
    const token = localStorage.getItem('token')
    if (token) {
      const { role } = parseJwt(token)
      const hasAccess = to.matched.some((record) => record.meta.roles && record.meta.roles.some((r) => r === role))
      if (hasAccess) {
        next()
      } else {
        next({ path: '/login' })
      }
    } else {
      next({ path: '/login' })
    }
  } else {
    next()
  }
})

export default router
